import React from 'react';
import { X, Trash2 } from 'lucide-react';
import './HistorySidebar.css';

const HistorySidebar = ({ history, onLoad, onClear, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="sidebar-overlay" onClick={onClose}>
      <div className="sidebar-container" onClick={(e) => e.stopPropagation()}>
        <div className="sidebar-header">
          <h2>Validation History</h2>
          <button onClick={onClose} className="close-btn"><X size={24} /></button>
        </div>
        <div className="sidebar-content">
          {history.length > 0 ? (
            history.map(item => (
              <div key={item.id} className="history-item" onClick={() => onLoad(item)}>
                <p>{item.idea}</p>
                <small>{new Date(item.id).toLocaleString()}</small>
              </div>
            ))
          ) : (
            <p className="empty-history">No history yet. Validate an idea to get started!</p>
          )}
        </div>
        {history.length > 0 && (
          <div className="sidebar-footer">
            <button onClick={onClear} className="clear-btn">
              <Trash2 size={16} /> Clear History
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistorySidebar;
